import { Module } from "vuex";
import {
  AlertState,
  AlertModel,
  AlertModelType,
  AlertCallbackModel
} from "./types";
import { RootState } from "@/store";
import mutations from "./mutations";

// export const ModuleName = "AlertModule";

export default {
  state: new AlertState(),
  mutations
} as Module<AlertState, RootState>;

/**
 * Api call wrapper
 * @param apiCall
 * @param title
 * @param callbackAction
 * @param commit
 */
export async function apiCallWithAlert(
  apiCall,
  title: String,
  callbackAction: () => void,
  commit
) {
  try {
    const res = await apiCall();
    if (res.status == 200 && res.data.Response == 0) {
      return res.data.Payload;
    } else {
      var message = title + " - ";
      if (res.status == 200)
        message += res.data.ResponseString + " " + res.data.Message;
      else message += res.status;

      commit(
        mutations.ADD_ALERT,
        new AlertModel(
          AlertModelType.Error,
          message,
          new AlertCallbackModel("common.retry", callbackAction)
        )
      );
    }
  } catch (e) {
    commit(
      mutations.ADD_ALERT,
      new AlertModel(
        AlertModelType.Error,
        title + e,
        new AlertCallbackModel("common.retry", callbackAction)
      )
    );
  }
}
